/** Brief 12, K3 - AI yordamchi va K3 - AI sozlamalari. */
export const uzB12Ai = {
  "yordamchi.title": "AI yordamchi",
  "yordamchi.scope.operator": "Sizning mijozlaringiz va bitimlaringiz bo'yicha",
  "yordamchi.scope.manager": "Filialingiz bo'yicha",
  "yordamchi.scope.owner": "Barcha filiallar bo'yicha",
  "yordamchi.new": "Yangi suhbat",
  "yordamchi.hello": "Salom, {name}. Nima yordam kerak?",
  "yordamchi.intro": "Bitim, mijoz, bron yoki to'lov haqida so'rang. Javoblar Kapitandagi ma'lumotdan olinadi, manbasi ko'rsatiladi.",
  "yordamchi.searching": "Ma'lumot qidirilmoqda…",
  "yordamchi.placeholder": "Savol yozing",
  "yordamchi.questionLabel": "AI yordamchiga savol",
  "yordamchi.send": "Yuborish",
  "yordamchi.sg.todayOperator": "Bugun nima qilishim kerak?",
  "yordamchi.sg.debtsOperator": "Qaysi mijozlarda qarz bor?",
  "yordamchi.sg.offers": "Sharm, 8–15 noyabr variantlari",
  "yordamchi.sg.docs": "Misrga qanday hujjat kerak?",
  "yordamchi.sg.todayBranch": "Bugun filialda nima muhim?",
  "yordamchi.sg.debts": "Qarzdorlar ro'yxati",
  "yordamchi.today": "Bugun AI nima qildi",
  "yordamchi.todayCount": "{count} harakat",
  "yordamchi.todayEmpty": "Bugun AI hali ishlamadi.",
  "yordamchi.approve": "Yuborish",
  "yordamchi.reject": "Rad etish",
  "yordamchi.sent": "Xabar yuborish navbatiga qo'yildi",
  "yordamchi.rejected": "Qoralama rad etildi",
  "yordamchi.whyReject": "Nega rad etdingiz?",
  "yordamchi.reason.wrong": "Noto'g'ri ma'lumot",
  "yordamchi.reason.tone": "Ohang",
  "yordamchi.reason.needless": "Keraksiz",
  "yordamchi.reason.other": "Boshqa",
  "yordamchi.permissions": "Ruxsatlar",
  "yordamchi.perm.afterHours": "Ish vaqtidan tashqari avtojavob",
  "yordamchi.perm.afterHoursSub": "Savollarni yig'adi, narx aytmaydi",
  "yordamchi.perm.proposal": "Tasdiqsiz variant yuborish",
  "yordamchi.perm.proposalSub": "O'chiq bo'lsa, operator tasdiqlaydi",
  "yordamchi.perm.comment": "Instagram kommentlariga javob",
  "yordamchi.perm.commentSub": "Faqat narx va sana savollari",
  "yordamchi.perm.discount": "Chegirma taklif qilish",
  "yordamchi.perm.discountSub": "Chegirmani faqat operator beradi: bu platforma qoidasi",
  "yordamchi.credits": "Kreditlar: {total}",
  "yordamchi.creditsOf": "Kreditlar: {total} / {monthly}",
  "yordamchi.creditsDays": " · ~{days} kun",
  "yordamchi.topUp": "To'ldirish",
  "yordamchi.permOn": "{name}: yoqildi",
  "yordamchi.permOff": "{name}: o'chirildi",
  "yordamchi.draftOpen": "Ochiq qoralamaga yozildi. Tasdiq matritsasida nashr qiling.",
  "yordamchi.emptyTitle": "AI yordamchi hali sozlanmagan",
  "yordamchi.emptyMessage": "Agentlik ma'lumotlari, hujjat talablari va tez javoblar to'ldirilgach, AI ular asosida javob beradi.",
  "yordamchi.emptyAction": "Sozlamalarga",
  "yordamchi.errorTitle": "AI yordamchi javob bermadi",
  "yordamchi.errorMessage": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "yordamchi.general": "Manba yo'q",
  "yordamchi.knowledgeSource": "Bilim bazasi",

  "aiS.nav": "AI agent bo'limlari",
  "aiS.page.overview": "Umumiy",
  "aiS.page.files": "Fayllar",
  "aiS.page.settings": "Tasdiq matritsasi",
  "aiS.page.journal": "Kundalik",
  "aiS.page.playground": "Sinov maydoni",
  "aiS.page.tests": "Sinov markazi",
  "aiS.page.memory": "Xotira takliflari",
  "aiS.page.knowledge": "Bilim bazasi",
  "aiS.page.posts": "Instagram postlari",
  "aiS.readOnly": "Menejer · faqat ko'rish. O'zgartirishni Egasi qiladi.",
  "aiS.denied": "{role} AI agentda faqat «Instagram postlari»ni ko'radi. Kerak bo'lsa, agentlik egasiga yozing.",
  "aiS.toPosts": "Instagram postlari",
  "aiS.title": "AI agent",

  "aiS.status": "Holat",
  "aiS.st.active": "Faol",
  "aiS.st.observe": "Kuzatuv rejimi",
  "aiS.st.stopped": "To'xtatilgan",
  "aiS.st.broken": "Ishlamayapti",
  "aiS.st.activeText": "AI tasdiq matritsasi bo'yicha o'zi javob beradi.",
  "aiS.st.observeText": "AI hali hech narsa yubormaydi. Javoblarni Tasdiq navbatida ko'rib chiqing, keyin avtomatik rejimga o'tkazing.",
  "aiS.st.stoppedText": "AI barcha kanallarda to'xtatilgan. Suhbatlar operatorlarga o'tgan.",
  "aiS.st.stoppedReason": "Sabab: {reason}",
  "aiS.st.brokenText": "Sozlanmagan — Platforma → Integratsiyalar → LLM",
  "aiS.observe": "Kuzatuv rejimi",
  "aiS.observeHint": "AI javob tayyorlaydi, lekin yubormaydi. Hammasi tasdiq navbatiga tushadi. Yangi agentlik shu rejimda boshlaydi; avtomatik rejimga faqat Egasi o'tkazadi.",
  "aiS.stop": "Favqulodda to'xtatish",
  "aiS.stopHint": "Barcha kanallarda AI darhol jim bo'ladi, suhbatlar operatorlarga o'tadi.",
  "aiS.stopConfirm": "To'xtatish",
  "aiS.stopReason": "Sabab (ixtiyoriy)",
  "aiS.stopDone": "AI to'xtatildi. Suhbatlar operatorga o'tdi: {count}",
  "aiS.resume": "AI'ni qayta yoqish",
  "aiS.resumed": "AI qayta yoqildi. Suhbatlar avtomatik qaytarilmaydi.",
  "aiS.cancel": "Bekor qilish",
  "aiS.channels": "Kanal bo'yicha pauza",
  "aiS.ch.telegram": "Telegram",
  "aiS.ch.instagram": "Instagram Direct",
  "aiS.ch.comment": "Instagram komment",
  "aiS.ch.accounts": "{count} akkaunt",
  "aiS.ch.posts": "{count} ta faol post",
  "aiS.ch.none": "Ulanmagan",
  "aiS.ch.paused": "Pauzada",
  "aiS.credits": "AI kreditlar",
  "aiS.billing": "Billing",
  "aiS.creditsOf": "/ {monthly}",
  "aiS.creditsDays": " · ~{days} kunga yetadi",
  "aiS.creditsToday": "Bugun {today} kredit · kunlik o'rtacha {average}",
  "aiS.summary": "Bugungi xulosa",
  "aiS.toJournal": "Kundalik",
  "aiS.summaryEmpty": "Bugungi xulosa birinchi suhbatdan keyin paydo bo'ladi.",
  "aiS.sum.first": "{count} ta suhbatga javob berdi.",
  "aiS.sum.firstSpeed": "{count} ta suhbatga javob berdi, birinchi javob o'rtacha {seconds} soniyada.",
  "aiS.sum.qualified": "{count} ta lid kvalifikatsiya qilindi.",
  "aiS.sum.handoffs": "{count} marta operatorga topshirdi",
  "aiS.sum.blocked": "{count} javob guardrail tomonidan to'xtatildi",
  "aiS.tasks": "Vazifalar",
  "aiS.schedule": "Jadval",
  "aiS.taskToday": "bugun {count}",
  "aiS.open": "Ochish",
  "aiS.tasksEmpty": "Vazifalar hali sozlanmagan.",
  "aiS.task.sales": "Birinchi javob, kvalifikatsiya, telefon olish, taklifgacha",
  "aiS.task.comments": "Postlarga ochiq javob va bitta shaxsiy xabar",
  "aiS.task.service": "Safar oldi eslatmalar, qaytgandan keyin fikr so'rash",
  "aiS.task.assist": "Qoralama, xulosa, keyingi savol taklifi",
  "aiS.task.analytics": "Kunlik xulosa, kechikkan to'lov eslatmasi",
  "aiS.task.custom": "Agentlikning o'z vazifasi",

  "aiS.fu.title": "Follow-up qoidalari",
  "aiS.fu.subtitle": "Kapitan AI vazifani o'zi yaratadi va sababini yozadi",
  "aiS.fu.example": "Misol: «Kecha variant yuborilgan, javob yo'q» · vazifa Vazifalar va Bosh sahifada Kapitan AI belgisi bilan chiqadi.",
  "aiS.fu.after": "keyin",
  "aiS.fu.every": "har",
  "aiS.fu.days": "kun",
  "aiS.fu.minutes": "daqiqa",
  "aiS.fu.switch": "{name}: yoqish",
  "aiS.fu.followup_offer_silent.t": "Taklifdan keyin javob bo'lmasa",
  "aiS.fu.followup_offer_silent.d": "Mijoz variantni ko'rdi, lekin yozmadi · qayta aloqa vazifasi",
  "aiS.fu.followup_not_interested.t": "«Qiziqish bildirmadi» dan keyin",
  "aiS.fu.followup_not_interested.d": "Boshqa yo'nalish yoki sana bilan qayta yozish vazifasi",
  "aiS.fu.followup_ai_off_reminder.t": "«AI o'chiq» suhbatlarda eslatma",
  "aiS.fu.followup_ai_off_reminder.d": "Operator javob bermasa eslatadi · 3 soatdan keyin menejerga",
  "aiS.fu.followup_morning_list.t": "Har ertalab ro'yxat",
  "aiS.fu.followup_morning_list.d": "{time} da har operatorga bugungi follow-up ro'yxati",
  "aiS.fu.saved": "{name}: saqlandi",

  "aiS.files.title": "Fayllar",
  "aiS.files.subtitle": "AI shu fayllardagi ko'rsatmalar bilan ishlaydi. Har nashr yangi versiya yaratadi; javoblar ostidagi versiya raqami shu.",
  "aiS.files.tab.rol": "Rol",
  "aiS.files.tab.xulq": "Xulq",
  "aiS.files.tab.bilim": "Bilim",
  "aiS.files.tab.iboralar": "Iboralar",
  "aiS.files.tab.xotira": "Xotira",
  "aiS.files.tab.limitlar": "Limitlar",
  "aiS.files.edit": "Muharrir",
  "aiS.files.diff": "Farq",
  "aiS.files.diffOf": "Farq v{from} – v{to}",
  "aiS.files.merged": "Birlashgan ko'rinish",
  "aiS.files.versions": "Versiyalar",
  "aiS.files.current": "joriy",
  "aiS.files.draft": "qoralama",
  "aiS.files.restore": "v{n} versiyasiga qaytarish",
  "aiS.files.restoreCurrent": "Joriy versiya",
  "aiS.files.restored": "v{n} qoralamaga olindi. Nashr qilguncha mijozga ta'sir qilmaydi.",
  "aiS.files.save": "Qoralamaga saqlash",
  "aiS.files.saved": "Qoralamaga saqlandi",
  "aiS.files.publish": "Nashr qilish · v{n}",
  "aiS.files.published": "Nashr qilindi. Keyingi javoblardan boshlab amal qiladi.",
  "aiS.files.noDiff": "Oldingi versiyaga nisbatan farq yo'q.",
  "aiS.files.bilimHint": "Bilim fayli yozuvlardan iborat, u Bilim bazasida tahrirlanadi.",
  "aiS.files.toKb": "Bilim bazasi",
  "aiS.files.noFile": "Agentning sozlamasi hali yo'q.",
  "aiS.persona.title": "Persona va ohang",
  "aiS.persona.warm": "Xushmuomala",
  "aiS.persona.middle": "O'rtacha",
  "aiS.persona.short": "Qisqa",
  "aiS.persona.intro": "Birinchi xabarda o'zini tanishtirish",
  "aiS.persona.introSub": "«{name} yordamchisi» deb yozadi",
  "aiS.persona.quiet": "Tinch soatlar",
  "aiS.persona.quietText": "{from} – {to} · proaktiv xabar yuborilmaydi, javob beriladi",
  "aiS.persona.quietNone": "Filial ish vaqti kiritilmagan · AI kecha-kunduz ishlaydi",
  "aiS.persona.wait": "Javobdan oldin kutish",
  "aiS.persona.waitHint": "soniya · mijoz ketma-ket yozsa, birlashtirib javob beradi",
  "aiS.persona.flow.new": "Yangi murojaat",
  "aiS.persona.flow.clarify": "Aniqlashtirish",
  "aiS.persona.flow.offer": "Taklif",
  "aiS.persona.flow.negotiate": "Muzokara",
  "aiS.persona.flow.pay": "To'lov",
  "aiS.persona.flow.after": "Sotuvdan keyin",
  "aiS.persona.flow": "Flow · AI qaysi bosqichgacha ishlaydi",
  "aiS.persona.flowHint": "Standart: taklifgacha AI; muzokara va to'lov odamda; sotuvdan keyingi qism yoqilgan.",
  "aiS.persona.ai": "AI",
  "aiS.persona.human": "odam",
  "aiS.persona.saved": "Qoralamaga saqlandi. Nashr qilishni unutmang.",
  "aiS.persona.phrases": "Iboralar kutubxonasi",
  "aiS.persona.more": "Batafsil sozlamalar",

  "aiS.matrix.title": "Tasdiq matritsasi",
  "aiS.matrix.subtitle": "Qaysi xabarni AI o'zi yuboradi (Avto) va qaysi biri operator tasdig'ini kutadi (Tasdiq). Tasdiq kutayotganlar Suhbatlar → Tasdiq navbatiga tushadi.",
  "aiS.matrix.kind": "Xabar turi",
  "aiS.matrix.auto": "Avto",
  "aiS.matrix.approve": "Tasdiq",
  "aiS.matrix.locked": "Doim tasdiq · o'zgartirib bo'lmaydi",
  "aiS.matrix.kind.reply": "Javob",
  "aiS.matrix.kind.proactive": "Proaktiv xabar",
  "aiS.matrix.kind.proposal": "Taklif",
  "aiS.matrix.kind.reminder": "Eslatma",
  "aiS.matrix.kind.requisites": "To'lov rekvizitlari",
  "aiS.matrix.publish": "Nashr qilish",
  "aiS.matrix.published": "Sozlamalar nashr qilindi",
  "aiS.matrix.commentOnly": "Komment faqat javob bo'lishi mumkin",
  "aiS.matrix.channels": "Akkaunt rejimi",
  "aiS.matrix.versions": "Sozlama versiyalari",
  "aiS.matrix.rollBack": "Qaytarish",
  "aiS.matrix.rolledBack": "Oldingi versiyaga qaytarildi",

  "aiS.journal.title": "Kundalik",
  "aiS.journal.subtitle": "AI bugun nima qildi, nima rejalashtirilgan va qayerda muammo bo'ldi.",
  "aiS.journal.all": "Hammasi",
  "aiS.journal.feed": "Harakatlar lentasi",
  "aiS.journal.credits": "{count} kredit",
  "aiS.journal.detail": "AI ishi tafsiloti",
  "aiS.journal.input": "Kirish xabari",
  "aiS.journal.inputNone": "— (rejalashtirilgan)",
  "aiS.journal.tools": "Ishlatilgan vositalar",
  "aiS.journal.toolsNone": "Vositalar ishlatilmadi",
  "aiS.journal.kb": "Bilim bazasi",
  "aiS.journal.guard": "Guardrail",
  "aiS.journal.guardOk": "Tekshiruvdan o'tdi",
  "aiS.journal.settings": "Sozlamalar",
  "aiS.journal.settingsV": "Versiya {id}",
  "aiS.journal.close": "Yopish",
  "aiS.journal.plan": "Rejalashtirilgan ishlar",
  "aiS.journal.planEmpty": "Rejalashtirilgan ish yo'q",
  "aiS.journal.problems": "Muammolar",
  "aiS.journal.problemsEmpty": "Bugun muammo yo'q",
  "aiS.journal.emptyTitle": "Bugun AI hali ishlamadi",
  "aiS.journal.emptyMessage": "AI to'xtatilgan yoki yangi xabar kelmagan.",
  "aiS.journal.yesterday": "Kechagi kunni ko'rish",
  "aiS.journal.backToday": "Bugunga qaytish",
  "aiS.journal.summary": "Bugun {runs} javob, {handoffs} handoff. {blocked} javob to'xtatildi. Kredit: {credits}.",

  "aiS.play.title": "Sinov maydoni",
  "aiS.play.subtitle": "Mijoz o'rnida yozing · AI joriy sozlamalar bilan javob beradi. Xabarlar hech kimga yuborilmaydi, kredit sarflanmaydi.",
  "aiS.play.scenario": "Stsenariy:",
  "aiS.play.placeholder": "Mijoz sifatida yozing…",
  "aiS.play.version": "Versiya",
  "aiS.play.live": "Joriy versiya",
  "aiS.play.draft": "Qoralama №{n}",
  "aiS.play.send": "Yuborish",
  "aiS.play.why": "Nega shunday javob?",
  "aiS.play.hide": "Yashirish",
  "aiS.play.empty": "Mijoz sifatida xabar yozing yoki stsenariy tanlang.",
  "aiS.play.ai": "AI · versiya {n}",

  "aiS.tests.title": "Sinov markazi",
  "aiS.tests.subtitle": "Sinov holatlari AI'ning kutilgan xulqini tekshiradi. Sozlamani o'zgartirgandan keyin ommaviy sinov qiling.",
  "aiS.tests.run": "Barcha sinovlarni ishga tushirish",
  "aiS.tests.summary": "O'tdi {passed} · o'tmadi {failed}",
  "aiS.tests.never": "Hali ishga tushirilmagan",
  "aiS.tests.compare": "Taqqoslash:",
  "aiS.tests.case": "Holat",
  "aiS.tests.expected": "Kutilgan xulq",
  "aiS.tests.passed": "o'tdi",
  "aiS.tests.failed": "o'tmadi",
  "aiS.tests.none": "—",
  "aiS.tests.empty": "Sinov holati yo'q.",
  "aiS.tests.blocked": "Muhim sinov o'tmadi: nashr bloklandi",

  "aiS.memory.title": "Xotira takliflari",
  "aiS.memory.subtitle": "AI operatorlar tuzatishlaridan yangi qoidalar taklif qiladi. Qabul qilingani Xotira fayliga yoziladi.",
  "aiS.memory.basis": "Asos: operatorlar {count} marta shunday qilgan",
  "aiS.memory.accept": "Qabul qilish",
  "aiS.memory.edit": "Tahrirlash",
  "aiS.memory.reject": "Rad etish",
  "aiS.memory.saveAccept": "Saqlash va qabul qilish",
  "aiS.memory.empty": "Yangi taklif yo'q",
  "aiS.memory.accepted": "Qoralamaga yozildi. Nashr qilguncha mijozga ta'sir qilmaydi.",

  "aiS.kb.title": "Bilim bazasi",
  "aiS.kb.subtitle": "AI faqat shu yerdagi ma'lumotlarga tayanib javob beradi. Muddati o'tgan yozuv avtomatik o'chadi.",
  "aiS.kb.upload": "Hujjat yuklash",
  "aiS.kb.add": "Yozuv",
  "aiS.kb.endless": "muddatsiz",
  "aiS.kb.until": "amal qiladi: {date}",
  "aiS.kb.expired": "muddati o'tgan",
  "aiS.kb.accept": "Qabul qilish",
  "aiS.kb.empty": "Bu to'plamda yozuv yo'q.",
  "aiS.kb.gaps": "Javobsiz savollar",
  "aiS.kb.gapsHint": "AI javob topa olmagan",
  "aiS.kb.gapTimes": "{count} marta",
  "aiS.kb.gapAdd": "Javob qo'shish",
  "aiS.kb.valid": "Amal qilish muddati",
  "aiS.kb.file": "Fayl (.docx yoki .pdf)",

  "aiS.posts.title": "Instagram postlari",
  "aiS.posts.subtitle": "Post kartochkasi AI'ga kommentlarga qanday javob berishni aytadi: yo'nalish, aksiya, izoh.",
  "aiS.posts.warn": "{count} ta post kartochkasiz, lekin komment ko'p",
  "aiS.posts.warnText": "AI umumiy javob beryapti, yo'nalish va aksiya noma'lum.",
  "aiS.posts.dest": "Yo'nalish",
  "aiS.posts.promo": "Aksiya",
  "aiS.posts.state": "Holat",
  "aiS.posts.note": "AI uchun",
  "aiS.posts.meta": "{count} komment",
  "aiS.posts.create": "Kartochka yaratish",
  "aiS.posts.edit": "Tahrirlash",

  "aiS.task.back": "AI agent",
  "aiS.task.procedures": "Protseduralar",
  "aiS.task.addProcedure": "+ Protsedura",
  "aiS.task.behaviour": "Vazifa xulqi",
  "aiS.task.tools": "Vositalar va ruxsatlar",
  "aiS.task.toolOff": "taqiqlangan",
  "aiS.task.toolDraft": "faqat tasdiq",
  "aiS.task.toolAuto": "matritsa bo'yicha",
  "aiS.task.routine": "Kun tartibi va limit",
  "aiS.task.jobs": "Rejalashtirilgan ishlar",
  "aiS.task.share": "Kredit ulushi",
  "aiS.task.sharePct": "% kunlik limitdan",
  "aiS.task.proc": "Protsedura: {name}",
  "aiS.task.procNew": "Yangi protsedura",
  "aiS.task.procName": "Nomi",
  "aiS.task.when": "QACHON",
  "aiS.task.do": "NIMA QILISH",
  "aiS.task.addWhen": "+ Shart qo'shish",
  "aiS.task.addDo": "+ Qadam qo'shish",
  "aiS.task.whenPrefix": "AGAR",
  "aiS.task.whenAnd": "VA",
  "aiS.task.whenPlaceholder": "Shart",
  "aiS.task.doPlaceholder": "Qadam",
  "aiS.task.remove": "O'chirish",
  "aiS.task.test": "Sinash",
  "aiS.task.save": "Saqlash",
  "aiS.task.saved": "Protsedura qoralamaga yozildi",
  "aiS.task.testNeeds": "Sinab bo'lmadi: kamida bitta shart va bitta qadam kerak.",
  "aiS.task.testing": "Sinov natijasi",
  "aiS.task.notFound": "Bunday vazifa topilmadi.",
  "aiS.task.runNow": "Hozir ishlatish",
  "aiS.task.jobStarted": "Ish ishga tushirildi",
  "aiS.task.noJobs": "Bu vazifa uchun jadval yo'q.",
  "aiS.task.saveBehaviour": "Xulqni saqlash",
} as const;
